export default __webpack_public_path__ + "static/pig06-23812e64f1d566e638ca7fed170f0ea9.png";